export default __webpack_public_path__ + "static/media/recurrence.8aa445c7.svg";